export default __webpack_public_path__ + "static/media/desktop.84afc4b3.jpg";